import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id", "name"]
const _hoisted_2 = {
  class: "accordion__content",
  ref: "accordionContent"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["accordion", {
      'accordion--open': _ctx.isOpen,
      'accordion--closed': !_ctx.isOpen,
      'accordion--hide-arrow': _ctx.foldOut,
    }]),
    ref: "accordion"
  }, [
    (_ctx.anchor)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          id: _ctx.anchor,
          name: _ctx.anchor,
          class: "accordion__anchor"
        }, null, 8 /* PROPS */, _hoisted_1))
      : _createCommentVNode("v-if", true),
    _cache[1] || (_cache[1] = _createTextVNode()),
    _createElementVNode("div", {
      class: "accordion__headline",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleClass && _ctx.toggleClass(...args)))
    }, [
      _renderSlot(_ctx.$slots, "head")
    ]),
    _cache[2] || (_cache[2] = _createTextVNode()),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "content")
    ], 512 /* NEED_PATCH */)
  ], 2 /* CLASS */))
}